import { render } from "./DietForm.vue?vue&type=template&id=5e053439"
import script from "./DietForm.vue?vue&type=script&lang=js"
export * from "./DietForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__